export default __webpack_public_path__ + "static/media/kid16.ec50472e.jpg";